'use strict';
var $ = require('jquery');

module.exports = {
    //Allow numbers, backspace, delete, left and right arrow, decimal point(once)
    isNumberKey: function (evt) {
        var key_codes = [48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 0, 8];
        var val = evt.target.value;
        if (!($.inArray(evt.which, key_codes) >= 0)) {
            if ((evt.which == 46) && (val.split('.').length == 1)) {
                return true;
            }
            return false;
        }
        if (!this.isValid(evt)) {
            return false;
        }
        return true;
    },

    //only allow numbers 0-9
    isInteger: function (event) {
        var pattern = /[0-9]/;
        return this.isKeyAllowed(event, pattern);
    },

    isValid: function (evt) {
        var text = evt.target.value;

        if ((evt.which != 46 || text.indexOf('.') != -1) && ((evt.which < 48 || evt.which > 57) && (evt.which != 0 && evt.which != 8))) {
            return false
        }

        if ((text.indexOf('.') != -1) && (text.substring(text.indexOf('.')).length > 2) && (evt.which != 0 && evt.which != 8) && (evt.target.selectionStart >= text.length - 2)) {
            return false;
        }
        return true;
    },

    noCopyPaste: function (evt) {
        if (evt.ctrlKey) {
            return false;
        }
        return true;
    },

    //Only allow keys that are specified in the pattern
    //evt: event
    //pattern: regEx
    isKeyAllowed: function (event, pattern) {
        //To get the char value of key, we or event.which and event.keyCode
        var keyChar = String.fromCharCode(event.which || event.keyCode);
        return pattern.test(keyChar) ? true : false;
    }
};



// WEBPACK FOOTER //
// C:/GH/1106/advice.noa.origination/~/eslint-loader!./utils/Keyboard.js